module.exports = __webpack_public_path__ + "img/process-4-1.b22eb7de.png";